<div class="search-container">
  <!-- Mostrar máscara si existe -->
  <!-- <div *ngIf="mask" class="mask-overlay">
    <span class="mask-text">{{ mask }}</span>
  </div> -->

  <input
    type="text"
    #searchInput
    [placeholder]="(mask ? mask : ('LISTING.SEARCH_PLACEHOLDER' | translate))"
  (focus)="setPlaceholder(mask ? mask : '')"
  (blur)="setPlaceholder(mask ? mask : '')"
    (input)="onSearch(searchInput.value)"
  />

  <ion-icon *ngIf="!searchTerm" src="../../../assets/svg/search.svg"></ion-icon>

  <!-- Botón para limpiar búsqueda (con posición absoluta) -->
  <ion-button
    *ngIf="searchTerm"
    fill="clear"
    size="small"
    class="clear-button"
    (click)="clearSearch(searchInput)">
    <ion-icon name="close" slot="icon-only"></ion-icon>
  </ion-button>
</div>
